import React from "react";
import { logout } from "../Utility";

/**
 * Standard project header — matches the header-area / icon_bg / head-title
 * / log-out-report pattern used across all other components.
 *
 * onBack — if provided, back arrow is shown; otherwise left side is empty
 */
export default function AppBar({ title, onBack }) {
  return (
    <div className="header-area">
      <div className="icon_bg" onClick={onBack || undefined} style={!onBack ? { visibility: "hidden", pointerEvents: "none" } : {}}>
        <img
          src={require("../../assets/images/back.png")}
          className="cso_icon_img"
          alt="back"
        />
      </div>
      <div className="head-title">{title}</div>
      <div className="log-out-report">
        <img
          src={require("../../assets/images/power-off.png")}
          onClick={() => logout(null, null, true)}
          alt="logout"
        />
      </div>
    </div>
  );
}

